import { DateTimeUtils } from '@common/utils';
import { EventInput } from '@fullcalendar/react';
import { DateTime } from 'luxon';
import { EntityScheduleOverridePreferenceRequest } from '@common/models/requests/EntityScheduleOverridePreferenceRequest';
import { EntitySchedulePreference } from '@common/models/Schedule/EntitySchedulePreference';

export interface IEntityOverrideSchedulePreference
  extends EntitySchedulePreference {
  overrideDate: DateTime;
  notes: string | undefined;
  createdBy: string | undefined;
  updatedBy: string | undefined;
  dateCreated: string | undefined;
  dateUpdated: string | undefined;
}

/**
 * This class represents the base of Schedule Override Preferences for both vets and templates for the preferences that are on ProcessHospitalScheduleModel which represent
 * the unmodified (unprocessed) schedule preferences. They will be on the base of the ProcessedHospitalScheduleModel and can be used to know what a preference or override was before it got modifed into a ComputedSchedulePreference
 */
export class EntityOverrideSchedulePreference extends EntitySchedulePreference {
  overrideDate: DateTime;
  notes: string | undefined;
  createdBy: string | undefined;
  updatedBy: string | undefined;
  dateCreated: string | undefined;
  dateUpdated: string | undefined;

  constructor(init: IEntityOverrideSchedulePreference) {
    super(init);

    this.overrideDate = DateTimeUtils.getAsDateTimeUTC(init.overrideDate)!;
    this.notes = init.notes;
    this.createdBy = init.createdBy;
    this.updatedBy = init.updatedBy;
    this.dateCreated = init.dateCreated;
    this.dateUpdated = init.dateUpdated;
  }

  /**
   * Takes the EntityOverrideSchedulePreference and returns a new calendar event
   */
  toCalendarEventInput(): EventInput {
    return {
      id: `${this.entityPreferenceId}_${this.entityType}`,
      extendedProps: {
        eventType: 'override',
        eventColor: this.scheduleBlockTypeColor,
        originalEntityId: this.entityId,
        originalEntityPreferenceId: this.entityPreferenceId,
        override: new EntityScheduleOverridePreferenceRequest({
          storeId: this.hospitalId,
          schedulePreferenceOverrideId: this.entityPreferenceId,
          entityId: this.entityId,
          entityType: this.entityType,
          schedulePreferenceId: this.schedulePreferenceId,
          scheduleBlockTypeId: this.scheduleBlockTypeId,
          startTime: this.startTime,
          endTime: this.endTime,
          dayOfWeek: this.dayOfWeek,
          overrideDate: this.overrideDate.toISO(),
          notes: this.notes,
          createdBy: this.createdBy,
          updatedBy: this.updatedBy,
          dateCreated: this.dateCreated,
          dateUpdated: this.dateUpdated,
        }),
      },
      resourceId: this.entityId + '_' + this.entityType,
      title: this.scheduleBlockTypeName,
      allDay: false,
      textColor: '#FFF',
      editable: true,
      startEditable: true,
      resourceEditable: true,
      backgroundColor: `${this.scheduleBlockTypeColor}`,
      className: 'appointmentEvent',
      borderColor: '#FFF',
      start: `${this.overrideDate.toFormat('yyyy-LL-dd')}T${this.startTime}`,
      end: `${this.overrideDate.toFormat('yyyy-LL-dd')}T${this.endTime}`,
    };
  }
}
